<template>
  <el-form-item :class="className" :style="itemFar.styleObj" v-if="subType === 'readonly'&&showList">
    <template v-slot:label>
      <el-form-item>
        <el-checkbox disabled checked>{{ checkText }}</el-checkbox>
      </el-form-item>
    </template>
    <!-- 要替换select，请默认插入具体内容 -->
    <slot>
      <el-row class="content" :class="itemFar.classRowName" :style="itemFar.styleRowObj" :gutter="24">
        <el-col class="content-style" v-for="(item, index) in selectList" :span="item.span ? item.span : 24" :key="'edit' + index" :style="{...item.colStyle}">
          <el-form-item :key="index" :label="item.placeholder">
            {{ itemFar.data[item.name] | filterData({ ...item, type: item.subType }) }}
          </el-form-item>
        </el-col>
      </el-row>
    </slot>
  </el-form-item>
  <el-form-item :class="className" :style="itemFar.styleObj" v-else-if="subType !== 'readonly'">
    <span></span>
    <template v-slot:label>
      <el-form-item>
        <el-checkbox :value="showList" @change="changeShow" :disabled="disabled">{{ checkText }}</el-checkbox>
      </el-form-item>
    </template>
    <!-- 要替换select，请默认插入具体内容 -->
    <slot>
      <!-- 要扩展，请在此处加判断，展示不同内容 -->
      <el-row class="content" :class="itemFar.classRowName" :style="itemFar.styleRowObj" :gutter="24" v-if="showList">
        <el-col class="custom-style" v-for="(item, index) in selectList" :span="item.span ? item.span : 24" :key="'edit' + index" :offset="item.offset" :style="{...item.colStyle}">
          <el-form-item :key="index" :prop="`${name}.${item.name}`" :rules="item.rules" :label="item.placeholder" :label-width="item.labelWidth">
            <el-select v-model="model[name][item.name]" :placeholder="$t('portal.qing-xuan-ze')" size="mini">
              <el-option v-for="(item, key) in item.option" :key="key" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </slot>
  </el-form-item>
</template>

<script>
export default {
  name: 'checkSelect',
  props: {
    itemFar:{
      type:Object,
      default:()=>({})
    },
    subType: {
      type: String,
      default: ''
    },
    checkText: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    model: {
      type: Object,
      default: () => ({})
    },
    selectList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    showList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  components: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    changeShow(e) {
      this.$emit('changeShow', { value: e, type: this.name });
    }
  }
};
</script>

<style lang="less">
// front and back
.el-form-item.client,.el-form-item.client_back{
  .el-checkbox__label{
    padding-left: 4px;
  }
  .el-form-item__label{
    .el-checkbox{
      position: relative;
      transform: translateX(-14px);
    }
  }
}
.el-form-item.supplier,.el-form-item.supplier_back{
  .el-checkbox__label{
    padding-left: 4px;
  }
}
// front
.el-form-item.client,.el-form-item.supplier{
  .content.el-row{
    margin-left: -8px !important;
    margin-right: 0 !important;
  }
}
.el-form-item.dealLink{
  &>.el-form-item__content{
    transform: translateX(-54px);
  }
  .el-form-item__label{
    .el-checkbox{
      position: relative;
      transform: translateX(10px);
    }
  }
}
// back
.el-form-item.supplier.supplier_edit,.el-form-item.client.client_edit{
  .content.el-row{
    margin-left: -6px !important;
    margin-right: 0 !important;
  }
}
.el-form-item.supplier_back,.el-form-item.client_back{
  .content.el-row{
    .el-form-item__content{
      text-align: left;
    }
    .content-style{
      &:first-of-type{
        margin-left: -42px;
      }
      &:nth-of-type(2){
        margin-left: -36px;
      }
      &:last-of-type{
        margin-left: 31px;
      }
    }
  }
}
.el-form-item.dealLink_back{
  &>.el-form-item__content{
    transform: translateX(-54px);
  }
  .el-form-item__label{
    .el-checkbox{
      position: relative;
      transform: translateX(39px);
    }
  }
}

// .content.margin_none{
//   margin-left: 0 !important;
//   margin-right: -4px !important;
// }
// .content {
//   .content-style {
//     padding-left: 0 !important;
//     &:nth-of-type(2){
//       margin-left: -42px;
//     }
//     &:last-of-type {
//       padding-right: 0 !important;
//       margin-left: 23px;
//     }
//     .el-form-item__content {
//       text-align: left;
//     }
//   }
// }
</style>
